import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';

import { store } from './store/index';
import Routes from './routes/index';
import { ThemeProvider } from 'styled-components';
import { themeDefault } from './assets/themes';
import { appInterceptor } from './core/config';
import { isSignedIn } from './core/helpers/auth';
import { autoLoginAction } from './store/Auth/action';
import { GlobalModal } from './shared/global-modal';

export const browserHistory = createBrowserHistory();

const App = () => {
	appInterceptor();
	const initialRender = (): void => {
		const res = isSignedIn();
		res && store.dispatch(autoLoginAction());
	};

	initialRender();

	return (
		<Provider store={store}>
			<ThemeProvider theme={themeDefault}>
				<GlobalModal>
					<Router history={browserHistory}>
						<Routes />
					</Router>
				</GlobalModal>
			</ThemeProvider>
		</Provider>
	);
};

export default App;
